import React from "react";
import styles from '../styles/depositBonus.module.scss'
import { useAssetImage } from "@/platforms/utils";
import SpriteContainer from "@/wmCompoments/spriteContainer";
import EventDetails from "./eventDetails";
import InviteInfo from "./inviteInfo";
import { useBaseConfig } from "../hooks/useInviteFriends";
import FadeIn from "@/compoments/fadeIn";

const DepositBonus = ({currentIndex}) => {
  const { baseConfigData } = useBaseConfig() || {}
  const rulesList = baseConfigData?.list?.[1]
  
  return (
     <FadeIn>
    <div className={styles.depositBonus}>

      {/* 图片 推荐链接等 */}
      <InviteInfo />

      {/* 活动内容 */}
      <EventDetails rulesList={rulesList} currentIndex={currentIndex}/>

    </div>
    </FadeIn>
  )
}

export default DepositBonus